import * as React from 'react';
import { Popup } from '../../services';

import SweetAlert from 'react-bootstrap-sweetalert';
import './Popup.scss';

interface Props {
  title: string;
  text?: string;

  type?: 'danger' | 'default' | 'success' | 'warning';
  icon?: string;
  iconColor?: string;

  outside?: boolean;
  warning?: boolean;

  cancelBtnStyle?: string;
  confirmBtnStyle?: string;
}

const SimplePopup: React.SFC<Props> = (props) => {
  const settings = {
    // warning: props.warning ? true : false,
    onConfirm: () => null,
    onCancel: props.outside ? (() => Popup.hide()) : (() => null),
    title: '',
    customClass: 'sweet-alert-wrapper',
  }
  var headerBgColor = ''
  switch (props.type) {
    case 'danger':
      headerBgColor = '#D5333E'
      break;
    case 'default':
      headerBgColor = '#0baaf4'
      break;
    case 'success':
      headerBgColor = 'green'
      break;
    case 'warning':
      headerBgColor = 'orange'
      break;
    default:
  }
  return (
    <SweetAlert
      {...settings}
      confirmBtnStyle={{display: 'none'}}
      closeOnClickOutside
      onCancel={() => Popup.hide()}
      >
      <div className='popup-wrapper'>
        <div className='popup-title-container' style={{ backgroundColor: headerBgColor }}>
          {/* { props.icon && (
            <Icon
              name={[props.icon, 'popup-icon'].join(' ')}
              iconColor={props.iconColor}
            />
          )} */}
          <div className='popup-title'>
            {props.title}
          </div>
          <div className='delete-btn' onClick={() => Popup.hide()}>
            <i className="fa fa-close"></i>
          </div>
        </div>
        <div className='popup-content'>
        { props.children }
        </div>
      </div>
    </SweetAlert>
  )
}

export default SimplePopup;
